import Schema, { required, optional } from 'AppReact/schema';

export default {
  orderBy: Schema('string', 'primitive', { defaultValue: '' }),
  orderDirection: Schema('string', 'primitive', { defaultValue: '' }),
  content: Schema({ label: required('string'), sortingField: required('string'), increasePadding: optional('boolean'), wrapHeader: optional('boolean') }, 'array', { defaultValue: [] })
};
